/* global dataLayer */
import Vue from 'vue';
import EventBus from '@/buses/EventBus';
import axios from 'axios';
import Color from 'color';
import moment from 'moment';
import _ from 'lodash';
import PlayerService from '@/services/PlayerService';
import {
  dynamicPHPPath,
  getServerUrl
} from '@utilities';

import {
  LTI_GRADE_SYNC_STATUS_MESSAGE,
} from '@Constants';


//Learners specicific state
const state = {
  youtubePlayerConfiguration: null,
  phpApiPrefix: dynamicPHPPath(window.location.hostname),
  playerApiPrefix: getServerUrl(),
  bulb: {},
  bulbAttempt: {},
  bulbCompleteTab: false,
  bulbCopyName: '',
  bulbVideoQualityLevels: [],
  // -- BROADCAST CODE STARTS
  broadcastId: null,
  broadcastActiveInteractionId: null,
  broadcastDisplayTime: null,
  broadcastFirebaseRaw: null,
  broadcastTeacherStatus: 'Offline',
  broadcastLearners: [],
  showBroadcastStartBtn: true,
  filterBroadcastLearners: [],
  ccOn: false,
  isBroadcast: false,
  isBroadcastTeacher: false,
  isBroadcastStudent: false,
  isFullScreen: false,
  isListcode: false,
  // -- BROADCAST CODE ENDS
  copyingBulb: false,
  captionReset: false,
  closeBulbInfo: false,
  currentSegmentSeek: false,
  desiredState:null,
  dimensions: {
    width: window.innerWidth,
    height: window.innerHeight,
  },
  displayTime: null,
  displayTimeStart: null,
  displayDuration: 0,
  groupFuzz: .02, // distance between interactions considered to be in a group by the designer
  hasNewInteractionDisplayAccess: false,
  initializingBulb: false,
  interactionRequest: null,
  isLiveSession: false,
  isPlaylist: false,
  playlistResourceLinkId: '',
  playlistLmsConsumerVersion: '',
  hasPlaylistScoreThreshold: false,
  isVimeoIframe: false,
  isPanoptoEmbeddedIframe: false,
  isVideoInstanceEmbeddedInIframe: false,
  liveSessionStartTime: 0,
  liveSessionUnixTime: 0,
  liveSessionTimeArray: [],
  lmsLaunch: false,
  localUnixTimeOffset: 0,
  lookaround: .1, // the fuzz time to search for interactions behind the playhead
  ltiExporting: false,
  ltiExportFailed: false,
  ltiSynced: false,
  lti13Launch: false,
  lmsIssuer: false,
  manualJump: false,
  manualPause: false,
  manualPlay: false,
  maxTime: 0,
  minSidebarPercent: 0, // the percentat width of the player screen that equates to min_sidebar_px for viewable size
  minSidebarPx: 420, // the smallest number of pixels wide the sidebar can be before it starts to collapse.
  playbackModeType: 'instructor',
  playerControlsDisplayType: 'Always',
  playerState: null,
  playButtonClicked: false,
  panoptoEmbedInitializationError: false,
  pqOrigin: null,
  proquestVideoUrl: null,
  previousSessionTime: 0,
  queryParams: {}, // a URLSearchParams object
  screenfull: null,
  scrubbing: false,
  selectedStreamQuality: [],
  sessionClicked: false,
  sessionId: null,
  sessionStartTime: 0,
  showHotspots: true, // Embedded YT duct tape for hotspots
  shownOutOfSyncToast: false,
  sidebarDragging: false, // whether or not the user is dragging the sidebar container
  sidebarStyle: 'desktop',
  sidebarTab: 'bulb-info-tab', // default tab for the sidebar
  sidebarTransitioned: false,
  settingsMenu: false,
  showInteractionsTab: false,
  sidebarOpen: false,
  sidebarWidth: 0,
  sidezoneOpen:false,
  slideInteraction: null, // if toggled to next or prev it will trigger bulbControls to select the next interaction from spm to set the interaction
  showCopyBulbModal: false,
  smallScreen: false,
  snackbar: {
    enabled: false,
    color: '',
    text: '',
    action: null,
    timeout: 5000,
  },
  startingSidebarSize: 0,
  studentSubmissionId: null,
  tokenRefresh:false,
  triggerFallbackStream: false,
  unixBulbEndTime: null,
  user: {
    branding: {},
    firstName: '',
    lastName: '',
  },
  userAgent: null,
  youtubeActiveStream: null,
  youTubePlayClicked: false,
  ytInitializing: false, // Duct tape for youtube in iframes not responding to user clicks. Iframe owner needs to add allow="autoplay *;"
  ytInitialized: false,
  ytVr: false,
  vimeoInitializing: false,
  vimeoInitialized: false,
  invokeVimeoFallbackCaptionLogic: false,
  panoptoInitializing: false,
  panoptoInitialized: false,
  showedMobileIOSPanoptoInitializeToast: false, // strictly for additional init logic for iOS Panopto bulbs
  slider: null, // Object reference for noUiSlider
  bulbIsPD: false,
  hideCaptionsEnableTranscript: false,
  lockedSidebarStyle: null,
  formatedDuration(time) {
    /**
     * converts a base number of seconds into formated time string
     *  97 -> '1:37'
     */
    const sec_num = parseInt(time, 10); // don't forget the second param
    let hours   = Math.floor(sec_num / 3600);
    let minutes = Math.floor((sec_num - (hours * 3600)) / 60);
    let seconds = sec_num - (hours * 3600) - (minutes * 60);
    if (!hours) hours = 0;
    if (!minutes) minutes = 0;
    if (!seconds) seconds = 0;
    return (hours >= 1 ? hours+":" : "") + (minutes < 10 ? "0"+minutes : minutes) + ":" + (seconds < 10 ? "0"+seconds : seconds);
  },
  formatReferer(ccUrl) {
    // check the ccUrl, if it's a PlayPosit url we need to add a unique referer
    if (ccUrl.includes("https://az857794.vo.msecnd.net/") || ccUrl.includes("https://cdn.playposit.com/")) {
      // check if the ccUrl already has query parameters in the string and add ? or & as needed
      if (ccUrl.includes('?')) return `&refer=${window.location.hostname}`;
      return `?refer=${window.location.hostname}`;
    }
    return '';
  },
  intersectingCrop(playerTime, skipSegments, offset = 0) {
    /**
     * takes a playerTime and checks to see intersects with any skip_segments
     * if it does, return that array of [skip_start, skip_end, display_end]
     * @param playerTime: a playerTime
     * @param skipSegments: array of crop objects that should be cropped from video [{start: 0, end: 15}, {start: 50, end: 60}]
     * @param offset: and offset for determining if the end crop time is included
     */
     // [ ] this is getting called every timeupdate, is there a way to cache this or speed it up?
    return _.find(skipSegments, o => o.start <= playerTime && playerTime < o.end);
  },
  getDisplayTime(video_id, time, increment = false) {
    /**
     * convert a player_time into a display_time (player_time -> display_time)
     * calculates the proper offsets using skip_segment and end/start times
     * @param video_id: the segment the player time is relative to
     * @param time: a player time to convert
     * @param increment: whether or not to add padding to the display time to preserve order when time is greater than duration
     */
    let player_time = time; // create new var to allow reassignment
    const video = _.find(state.bulb.bulbVideos, {id: video_id}); // get segment from id
    if (!video) return 0;
    // if (player_time <= video.playerStartTime) player_time = video.playerStartTime
    if (player_time >= video.playerEndTime) {
      // player time is past the player end time
      if (!increment) return video.displayEnd // return the displayTime
      else return video.displayEnd - state.videos.fuzz_time + (player_time / 100000); // return displaytime with offset
    }
    // check if player_time intersects with a skip segment, update time to end time of skip if true
    const current_crop = state.intersectingCrop(player_time, video.allCrops);
    if (current_crop) player_time = current_crop.end;
    // calculate the proper display_time
    let displayTime = video.displayStart + (player_time - state.playerTimeSkips(video, time));
    // if there is a start_time, the time could be a negative number, so we pull it up to 0
    // console.log(time, '\t',displayTime,'=' , video.displayStart, '+', (player_time), '-', state.playerTimeSkips(video, time))
    return Math.max(displayTime, 0);
  },
  playerTimeSkips(video, player_time) {
    let offset = 0;
    video.allCrops.forEach((skip) => {
      if (skip.start <= player_time) {
        offset += skip.end - skip.start;
      }
    });
    return offset;
  },
  setFirstFocus(el){
    const focuses = el.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    if (focuses.length) focuses[0].focus();
  },
  ppWrapper: null,
  thirdPartyCookiesEnabled: true,
}

const mutations = {
    updateYoutubePlayerConfiguration: (state, youtubePlayerConfiguration) => {
      state.youtubePlayerConfiguration = youtubePlayerConfiguration;
    },
    openInteractionsTab: (state) => {
      if (!state.showInteractionsTab && state.sidebarOpen) state.closeBulbInfo = false;
      else state.closeBulbInfo = true;
      state.sidezoneOpen = true;
      state.showInteractionsTab = true;
      state.sidebarOpen = true;
    },
    recenterCaptions(state) {
      state.captionReset = true;
    },
    setActiveInteractionGroup(state, group) {
      state.activeInteractionGroup = group;
    },
    setCcOn(state, bulbData) {
      if (
        (
          bulbData.bulb.config.preloadCaptions
          || bulbData?.overwritePreloadCaptions
        )
        && bulbData.bulbVideo.bulbVideoCaptions.length
      ) {
        if (!state.ccOn) state.ccOn = true;
        // look for english caption set
        const english = _.find(bulbData.bulbVideo.bulbVideoCaptions, c => c.label.toLowerCase() === 'english');
        return _.get(english, 'id', bulbData.bulbVideo.bulbVideoCaptions[0].id)
      }
      // if not preloaded by teacher setting or no bulb video captions set to -1
      return -1;
    },
    setBulb(state, bulb) {
      /*
        set the default values for the bulb
      */
      state.isPlaylist = (
        state.queryParams.get('playlist') === 'true'
        || state.queryParams.get('playlist') === '1'
      );
      if (state.queryParams.has('playlistResourceLinkId')) {
        state.playlistResourceLinkId = state.queryParams.get('playlistResourceLinkId');
      }
      if (state.queryParams.has('playlistLmsConsumerVersion')) {
        state.playlistLmsConsumerVersion = state.queryParams.get('playlistLmsConsumerVersion');
      }
      state.hasPlaylistScoreThreshold = state.queryParams.has('scoreThreshold');
      // add disable features to bulb config
      const disabled = _.has(bulb.teachers[0],'school.disableFeatures') ? bulb.teachers[0].school.disableFeatures : 0;
      if (!bulb.config) bulb.config = {}
      if (_.has(bulb, 'config.fast_yes')) bulb.config.fast_yes = parseInt(bulb.config.fast_yes);
      if (_.has(bulb, 'config.retry_yes')) bulb.config.retry_yes = parseInt(bulb.config.retry_yes);
      if (_.has(bulb, 'config.rewind_yes')) bulb.config.rewind_yes = parseInt(bulb.config.rewind_yes);
      if (_.has(bulb, 'config.skip_yes')) bulb.config.skip_yes = parseInt(bulb.config.skip_yes);
      if (_.has(bulb, 'config.mark_yes')) bulb.config.mark_yes = parseInt(bulb.config.mark_yes);
      bulb.config.chat_disabled = Boolean(Math.round(disabled/10)%2);
      bulb.config.score_disabled = Boolean(Math.round(disabled/100)%2);
      
      if (
        !state.isPlaylist
        && _.has(bulb, 'config.scoreThreshold')
      ) {
        bulb.config.scoreThreshold = +bulb.config.scoreThreshold;
      } else if (
        state.isPlaylist
        && state.hasPlaylistScoreThreshold
      ) {
        bulb.config.scoreThreshold = +state.queryParams.get('scoreThreshold');
      } else if (
        state.isPlaylist
        && !state.hasPlaylistScoreThreshold
      ) {
        bulb.config.scoreThreshold = null;
      }

      bulb.config.speed = 1;
      bulb.config.volume = 40;
      bulb.config.mute = false;
      // grabs original bulb and interaction configurations for playback mode toggle
      bulb.originalValues = {
        bulb: {
          fast_yes: bulb.config.fast_yes,
        },
        requiredInteractions: []
      };
      // parse teacher.userInfo and set caption Preloading
      bulb.masterTeacher = _.find(bulb.teachers, (teacher) => teacher.bulbTeacher.bulbRole === 1) || bulb.teachers[0];
      _.map(bulb.teachers, t => {
        if (typeof t.userInfo === 'string') t.userInfo = JSON.parse(t.userInfo);
        // If the preloadCaptions variable hasn't been set yet or if the teacher is the creator - set it
        if (!_.has(bulb, 'config.preloadCaptions')) {
          bulb.config.preloadCaptions = _.has(t, 'userInfo.captions_yes') ? t.userInfo.captions_yes : false;
        }
      });

      // overwrite fast_yes for preview users
      if (state.user.userType === 'teacher' || state.user.isTeacherLmbAttempt) bulb.config.fast_yes = true;
      // add props for vue logic to bulb videos
      let dur = 0;
      bulb.hasCaptions = false;
      bulb.bulbVideos = _.sortBy(bulb.bulbVideos, 'order')
      bulb.bulbVideos.forEach((bulbVideo, v) => {
        bulbVideo.initialized = false;
        bulbVideo.metadataInitialized = false;
        bulbVideo.deviceInitialized = false;
        bulbVideo.videoInitialized = false;
        bulbVideo.streamIndex = 0;  // might want to set active_stream here/ use index?
        if (bulbVideo.bulbVideoCaptions.length && !bulb.hasCaptions) bulb.hasCaptions = true;
        bulbVideo.captionId = (() => {
          // set default bulbVideo caption id
          if (
            (
              (
                bulb.config.preloadCaptions // preloadCaptions is derived from a userProfile setting to enable captions
                && !_.get(bulb, 'config.captions_disabled', false)
              )
              || bulb.config?.enable_transcript
            )
            && bulbVideo.bulbVideoCaptions.length
          ) {
            if (!state.ccOn) state.ccOn = true;
            // look for english caption set
            const english = _.find(bulbVideo.bulbVideoCaptions, c => c.label.toLowerCase() === 'english');
            return _.get(english, 'id', bulbVideo.bulbVideoCaptions[0].id)
          }
          // if not preloaded by teacher setting or no bulb video captions set to -1
          return -1;
        })(),
        bulbVideo.initializedAttempts = 0;

        if (typeof bulbVideo.playerStartTime !== 'number') bulbVideo.playerStartTime = 0;
        if (typeof bulbVideo.playerEndTime !== 'number' || bulbVideo.playerEndTime === Math.floor(bulbVideo.video.playerDuration)) {
          bulbVideo.playerEndTime = bulbVideo.video.playerDuration;
        }
        if (!bulbVideo.skip) bulbVideo.skip = []; // generate skip array if it doesn't exist
        bulbVideo.allCrops = []
        // add start time to skip array
        if (bulbVideo.playerStartTime && bulbVideo.playerStartTime !== 0 && !_.find(bulbVideo.skip, {start: 0})) {
          bulbVideo.allCrops.push({ start: 0, end: bulbVideo.playerStartTime })
        }
        // add end time to skip array
        if (bulbVideo.playerEndTime && bulbVideo.playerEndTime !== bulbVideo.video.playerDuration && !_.find(bulbVideo.skip, {end: bulbVideo.video.playerDuration})) {
          bulbVideo.allCrops.push({ start: bulbVideo.playerEndTime,  end: bulbVideo.video.playerDuration})
        }

        bulbVideo.skip.forEach(skip => {
      	  // defaults crops that are missing start
      	  if (_.isNil(skip.start)) skip.start = 0;
      	  // defualt crops that are missing end
      	  if (_.isNil(skip.end)) skip.end = 0;
      	  if (skip.start && skip.start < 0) skip.start = 0;
      	  if (skip.end && !_.isNil(bulbVideo.video.playerDuration) && skip.end > bulbVideo.video.playerDuration) skip.end = bulbVideo.video.playerDuration;
      	  if (skip.end - skip.start > 0) {
      	    //add skip segments to all crop array
      	  	bulbVideo.allCrops.push(skip)
      	  }
      	});
      	// remove duplicate skip segments
      	bulbVideo.allCrops = _.uniqWith(bulbVideo.allCrops, _.isEqual);
      	//calculate bulbVideo displayDuration
        bulbVideo.displayDuration = _.reduce(bulbVideo.allCrops, (duration, skip) => duration - (skip.end - skip.start), bulbVideo.video.playerDuration);

        bulbVideo.displayStart = dur
        bulbVideo.displayEnd = bulbVideo.displayStart + bulbVideo.displayDuration;
        bulbVideo.userSetEndCrops = bulbVideo.playerEndTime !== bulbVideo.video.playerDuration;
        bulbVideo.bulbVideoStreams = bulbVideo.video.videoStreams // map bulbVideos.video.videoStreams to bulbVideo
        dur += bulbVideo.displayDuration;
      });
      // add props for vue logic to bulb interactions
      let overflowIndex = 0;
      _.orderBy(bulb.interactions, 'displayInTime').forEach((i) => {
        // add defaults for questions here
        if (!i.displayOutTime || i.displayOutTime < i.displayInTime) i.displayOutTime = i.displayInTime;
        if (i.displayInTime >= dur - .1) {
          // offset displayInTime before duration but maintaining order of displayTime
          overflowIndex += 1;
          i.displayInTime = dur - (1 / overflowIndex / 100);
          i.displayOutTime = dur;
        }
        if (i.displayOutTime > dur) i.displayOutTime = dur;
        i.isRequired = (() => {
          // Storing requiredInteraction ids for instructor/learner toggle
          if (_.get(i, 'isRequired') === null && !_.get(bulb, 'config.skip_yes')) bulb.originalValues.requiredInteractions.push(i.id);
          else if (_.get(i, 'isRequired')) bulb.originalValues.requiredInteractions.push(i.id);
          // if student, follow standard logic for setting required
          if (state.user.userType === 'teacher') return 0;
          if (state.user.isTeacherLmbAttempt && i.interactionType === 'discussion_q' && i.config.template_key === 'peer_review') {
            return false;
          }
          if (i.isRequired === null) return _.has(bulb, 'config.skip_yes') ? !bulb.config.skip_yes : 1;
          return i.isRequired;
        })()
        if (i.random === null) i.random = false;
        if (i.rewind === null) i.rewind = _.has(bulb, 'config.rewind_yes') ? bulb.config.rewind_yes : 0;
        if (i.jumpCorrect) i.jumpCorrect = parseFloat(i.jumpCorrect) || null;
        if (i.jumpIncorrect) i.jumpIncorrect = parseFloat(i.jumpIncorrect) || null;
        if (_.isNil(i.position)) i.position = {};
        if (_.isNil(i.position.position_type)) i.position.position_type = 'sidebar';
        if (_.isNil(i.position.opacity)) i.position.opacity = 1;
      });
      state.bulbCopyName = `Copy of ${bulb.name}`;
      Vue.set(state, 'bulb',  _.assign({}, state.bulb, bulb))
    },
    setBulbAttempt(state, bulbAttempt) {
      Vue.set(state, 'bulbAttempt', _.assign({}, state.bulbAttempt, bulbAttempt))
    },
    setBulbCopyName: (state, val) => state.bulbCopyName = val,
    setBulbHasCaptions: (state) => state.bulb.hasCaptions = true,
    setBulbVideoQualityLevels: (state, data) => {
      state.bulbVideoQualityLevels.push({
        index: data.videoStreamIndex,
        qualityLevels: data.qualityLevels,
      });
    },
    setCaptionReset: (state, val) => state.captionReset = val,
    setCloseBulbInfo: (state, val) => state.closeBulbInfo = val,
    setCurrentSegmentSeek: (state, val) => {
      state.currentSegmentSeek = val
      if (val) {
        // reset seeked event after fired
        Vue.nextTick(() => {
          state.currentSegmentSeek = false
        })
      }

    },
    setDesiredState: (state, val) => state.desiredState = val,
    setDimensions: (state, dims) => {
      if (dims.width) state.dimensions.width = dims.width;
      if (dims.height) state.dimensions.height = dims.height;
    },
    setDisplayTime: (state, displayTime) => state.displayTime = displayTime,
    setDisplayTimeStart: (state, val) => state.displayTimeStart = val,
    setDisplayState(state, val) {
      state.displayTime = val
    },
    setHasNewInteractionDisplayAccess: (state, value) => state.hasNewInteractionDisplayAccess = value,
    setYouTubePlayClicked: (state, value) => {
      state.youTubePlayClicked = value;
    },
    setInitializingBulb(state, val) {
      state.initializingBulb = val;
    },
    setInteractionRequest(state, request) {
      state.interactionRequest = null,
      state.interactionRequest = request;
    },
    setIsBroadcast(state, val) {
      state.isBroadcast = val
    },
    setIsListcode(state, val) {
      state.isListcode = val;
    },
    setIsLiveSession(state, val) {
      state.isLiveSession = val;
    },
    setIsBroadcastTeacher(state, val) {
      state.isBroadcastTeacher = val
    },
    setIsBroadcastStudent(state, val) {
      state.isBroadcastStudent = val
    },
    setIsFullScreen: (state, value) => {
      state.isFullScreen = value
    },
    setLiveSessionStartTime: (state, unixTime) => {
      state.liveSessionStartTime = unixTime;
    },
    setLiveSessionUnixTime: (state, value) => {
      state.liveSessionUnixTime = value;
    },
    setLookaround: (state, val) => state.lookaround = val,
    setLmsLaunch: (state, val) => state.lmsLaunch = Boolean(val),
    setLtiExporting: (state, val) => state.ltiExporting = val,
    setLtiExportFailed: (state, val) => state.ltiExportFailed = val,
    setLtiSynced:(state, val) => state.ltiSynced = val,
    setManualJump(state, val) {
      state.manualJump = val;
    },
    setManualPause(state, val) {
      state.manualPause = val;
    },
    setManualPlay(state, val) {
      state.manualPlay = val;
    },
    setMaxTime(state, val) {
      state.maxTime = val;
    },
    setMinSidebarPercent: (state, val) => state.minSidebarPercent = val,
    setPlaybackModeType: (state, val) => state.playbackModeType = val,
    setPlayerControlsDisplayType: (state, val) => state.playerControlsDisplayType = val,
    setPlayButtonClicked: (state, value) => state.playButtonClicked = value,
    setPanoptoEmbedInitializationError: (state, value) => state.panoptoEmbedInitializationError = value,
    setPreviousSessionTime: (state, val) => state.previousSessionTime = val,
    setQueryParams: (state, urlSearchParams) => state.queryParams = urlSearchParams,
    setScreenfull: (state, val) => state.screenfull = val,
    setScrubbing(state, val) {
      state.scrubbing = val;
    },
    setSessionClicked: (state, value) => {
      state.sessionClicked = value;
    },
    setSessionId: (state) => {
      if (state.user.userType === 'teacher') {
        state.sessionId = `t${_.get(state, 'user.id')}:${state.bulb.id}:${moment.utc(state.sessionStartTime).valueOf()}`;
      } else if (state.user.userType === 'student') {
        state.sessionId = `s${_.get(state, 'user.id')}:${state.bulb.id}:${moment.utc(state.sessionStartTime).valueOf()}`;
      } else {
        state.sessionId = `a:${state.bulb.id}:${moment.utc(state.sessionStartTime).valueOf()}`;
      }
    },
    setSessionStartTime: (state, time) => state.sessionStartTime = time,
    setSettingsMenu(state, open) {state.settingsMenu = open},
    setShowCopyBulbModal(state, show) {
      if (!show) state.bulbCopyName = `Copy of ${state.bulb.name}`;
      state.showCopyBulbModal = show;
    },
    setShowHotspots: (state, value) => {
      state.showHotspots = value;
    },
    setShowInteractionsTab: (state, show) => {
      if (!show) state.closeBulbInfo = false;
      state.showInteractionsTab = show;
    },
    setSmallScreen: (state, val) => {
      state.smallScreen = val;
    },
    setSidebarDragging: (state, dragging) => {
      // console.log('sidebarDraggingChange',state.sidebarDragging, dragging, state.startingSidebarSize, state.sidebarWidth)
      if (!state.sidebarDragging && dragging) {
        // sidebar is getting dragged. Record the original width so we can compare when dragging ends to determine if we should auto collapse or not.
        // console.log('setStartingWidth to', state.sidebarWidth)
        state.startingSidebarSize = state.sidebarWidth
      } else if (state.sidebarDragging && !dragging) {
        if (state.sidebarWidth < state.minSidebarPx) {
          // dragging has end less than the minimum sidebar pixel width
          if (state.sidebarWidth < state.startingSidebarSize) {
            // they were dragging it closed
            state.sidebarWidth = 0
          } else {
            // the starting width was less so they were dragging it open, open it to the minimum width
            state.sidebarWidth = state.minSidebarPx
          }
        }
      }
      state.sidebarDragging = dragging;
    },
    setSidebarTab: (state, tab) => state.sidebarTab = tab,
    setSidebarTransitioned: (state, val) => {
      state.sidebarTransitioned = val;
      Vue.nextTick(() => {
        state.sidebarTransitioned = false;
      })
    },
    setSidebarWidth: (state, widthPx) => {
      state.sidebarWidth = widthPx
    },
    setSidezoneOpen: (state, open) => state.sidezoneOpen = open,
    setSlideInteraction: (state, direction) => state.slideInteraction = direction,
    setSnackbar:(state, options) => {
      state.snackbar.enabled = false;
      if (options.color === 'warning') options.textColor = 'black';
      Vue.nextTick(() => {
        state.snackbar = {
          action: options.action,
          autoHeight: _.has(options,'autoHeight') ? options.autoHeight : false,
          bluescreen: options.bluescreen,
          color: options.color,
          class: options?.class,
          enabled: true,
          spinner: options.spinner || false,
          text: options.text,
          excludeOk: options.excludeOk || false,
          textColor: options.textColor || 'white',
          timeout: _.has(options,'timeout') ? options.timeout : 5000,
        }
      })
    },
    setSelectedStreamQuality: (state, stream) => {
      Vue.set(state.selectedStreamQuality, stream.streamIndex, stream.bs);
    },
    setStudentSubmissionId: (state, submissionId) => {
      state.studentSubmissionId = submissionId;
    },
    setPlayerState(state, val) { state.playerState = val},
    setUnixBulbEndTime: (state, value) => {
      state.unixBulbEndTime = value;
    },
    setUser(state, user) {
      // user.userType = 'DEMO_userType';
      Vue.set(state, 'user', _.assign({}, state.user, user));
    },
    setUserAgent(state, userAgent) {
      state.userAgent = userAgent;
    },
    setSidebarOpen(state, sidebarOpen) {
      if (sidebarOpen) {
        state.sidezoneOpen = true;
      }
      state.sidebarOpen = sidebarOpen;
    },
    setYoutubeActiveStream: (state, value) => {
      state.youtubeActiveStream = value;
    },
    toggleCC: (state) => {
      state.ccOn = !state.ccOn;
    },
    triggerBulbCompleteTab: (state) => {
      state.bulbCompleteTab = !state.bulbCompleteTab;
    },
    updateBulbAttemptPointsEarned(state, pointsEarned) {
      state.bulbAttempt.pointsEarned = pointsEarned;
    },
    updateFastYes: (state, value) => {
      state.bulb.config.fast_yes = value;
    },
    youtubeIframeInit: (state, bulbVideoId) => {
      // Duct tape for youtube in iframes not responding to user clicks. Iframe owner needs to add allow="autoplay *;"
      if (!state.ytInitialized && !state.ytInitializing){
        state.ytInitializing = bulbVideoId;
        // Hides hotspots which can cover the play button YT needs to initialize
        state.showHotspots = false;
      }
    },
    panoptoIframeInit: (state, bulbVideoId) => {
      // Duct tape for Panopto in iframes not responding to user clicks. Iframe owner needs to add allow="autoplay *;"
      if (!state.panoptoInitialized && !state.panoptoInitializing){
        state.panoptoInitializing = bulbVideoId;
        // Hides hotspots which can cover the play button Panopto needs to initialize
        state.showHotspots = false;
      }
    },
    setPanoptoInitializing: (state, value) => {
      state.panoptoInitializing = value;
    },
    setShowedMobileIOSPanoptoInitializeToast: (state, value) => {
      state.showedMobileIOSPanoptoInitializeToast = value;
    },
    vimeoIframeInit: (state, bulbVideoId) => {
      // Duct tape for vimeo in iframes not responding to user clicks. Iframe owner needs to add allow="autoplay *;"
      if (!state.vimeoInitialized && !state.vimeoInitializing){
        state.vimeoInitializing = bulbVideoId;
        // Hides hotspots which can cover the play button Vimeo needs to initialize.
        state.showHotspots = false;
      }
    },
    youtubeInitialized: (state, val) => {
      // Duct tape for youtube in iframes not responding to user clicks. Iframe owner needs to add allow="autoplay *;"
      state.ytInitializing = false;
      state.ytInitialized = true;
    },
    VimeoInitialized: (state) => {
      // Duct tape for Vimeo videos in iframes not responding to user clicks. Iframe owner needs to add allow="autoplay *;"
      state.vimeoInitializing = false;
      state.vimeoInitialized = true;
    },
    PanoptoInitialized: (state) => {
      // Duct tape for Panopto videos in iframes not responding to user clicks. Iframe owner needs to add allow="autoplay *;"
      state.panoptoInitializing = false;
      state.panoptoInitialized = true;
    },
    setIsVimeoIframe: (state, value) => state.isVimeoIframe = value,
    setIsPanoptoEmbeddedIframe: (state, value) => { state.isPanoptoEmbeddedIframe = value },
    setIsVideoInstanceEmbeddedInIframe: (state, value) => state.isVideoInstanceEmbeddedInIframe = value,
    setYoutubeVr: (state, val) => state.ytVr = val,
    updatePqOrigin: (state, pqOrigin) => state.pqOrigin = pqOrigin,
    updateProquestVideoUrl: (state, proquestVideoUrl) => state.proquestVideoUrl = proquestVideoUrl,
    // -- BROADCAST CODE STARTS
    setBroadcastBulbDefaults(state) {
      try {
        // -- update defaults for state.bulb config
        state.bulb.config.fast_yes = true;
        state.bulb.config.skip_yes = true;
        state.bulb.config.rewind_yes = true;
        state.bulb.config.retry_yes = false;

        if(state.user && state.user.userType === 'student') {
          state.bulb.bulbVideos.forEach(video => {
            video.bulbVideoCaptions = [];
            video.bulbVideoStreams = [
              {
                "id": 'broadcast',
                "type": "m3u8",
                "url": "https://bunny.playposit.com/hls/vim-351051540/manifest0/playlist.m3u8",
                "videoId": 'broadcast-video',
                "order": 0,
                "created": "2019-01-16T23:31:42.000Z",
                "updated": "2019-07-15T08:35:22.000Z",
                "archived": "2100-11-30T18:30:00.000Z",
                "name": "video - 1"
              }
            ]
          });
        }
        const broadcastInteractions = [];
        // -- update defaults for interactions config
        state.bulb.interactions.forEach((i) => {
          // -- set isrequired for all question false
          i.isRequired = false;
          // -- remove all jumps from the question for students
          if (state.user.userType === 'student'){
            i.interactionText = i.interactionText.replace('data-pp-jump', 'data-pp-broadcast').replace('pp-jump', 'pp-broadcast');
          }
          if(i.interactionOptions !== null) i.interactionOptions = i.interactionOptions.map(o => {
            if(o.option) o.option = o.option.replace('data-pp-jump', 'data-pp-broadcast').replace('pp-jump', 'pp-broadcast');
            if(o.feedback) o.feedback = o.feedback.replace('data-pp-jump', 'data-pp-broadcast').replace('pp-jump', 'pp-broadcast');
            o.jump = null;
            return o;
          });
          if(i.config && i.config.feedback) i.config.feedback = i.config.feedback.replace('data-pp-jump', 'data-pp-broadcast').replace('pp-jump', 'pp-broadcast');
          i.jumpCorrect = null;
          i.jumpIncorrect = null;

          // -- update position to be sidebar only
          i.position = {"position_type": "sidebar"}
          i.rewind = true;
          i.pause = true;
          // -- fix for displayOutTime so question does not appear again when in broadcast
          i.displayOutTime = i.displayInTime;
          if (!['secondary_stream'].includes(i.interactionType)) {
            // strip secondary streams from bulb
            broadcastInteractions.push(i);
          }
        });
        state.bulb.interactions = broadcastInteractions;
      } catch (e) {
        dataLayer.errorLog(e)
      }
    },
  setBroadcastId: (state, code) => state.broadcastId = code,
  setBroadcastActiveInteractionId: (state, id) => state.broadcastActiveInteractionId = id,
  setBroadcastDisplayTime: (state, time) => state.broadcastDisplayTime = time,
  setBroadcastFirebaseRaw: (state, raw) => state.broadcastFirebaseRaw = raw,
  setBroadcastTeacherStatus: (state, raw) => state.broadcastTeacherStatus = raw,
  setShowBroadcastStartBtn: (state, value) => state.showBroadcastStartBtn = value,
  setBroadcastLearners: (state, raw) => {
    const learnerExists = _.findIndex(state.broadcastLearners, {learnerId: raw.learnerId + '' });
    console.log('learnerExists:: ', learnerExists, state.broadcastLearners, raw);
    if(learnerExists === -1) {
      Vue.nextTick(() => {
        state.broadcastLearners.push({
          learnerId: raw.learnerId+'',
          updated: raw.data.updated,
        });
      });
      PlayerService.getBroadcastLearnerDetails(raw.learnerId)
        .then((student) => {
          //console.log('student:: ', student.data);
          if(student.data && student.data.error === null) {
            const learnerExists = _.findIndex(state.broadcastLearners, {learnerId: raw.learnerId + '' });
            Vue.set(state.broadcastLearners, learnerExists, Object.assign(state.broadcastLearners[learnerExists], {learnerDetails: student.data.data, data: raw.data, updated: raw.data.updated}));
          }
        });
    }
    else {
      //console.log('updating learner:: ', learnerExists, JSON.parse(JSON.stringify(state.broadcastLearners[learnerExists])), raw.data);
      Vue.set(state.broadcastLearners, learnerExists, Object.assign(state.broadcastLearners[learnerExists], {data: raw.data, updated: raw.data.updated}));
      Vue.nextTick(() => {
        console.log('updated learner:: ', state.broadcastLearners[learnerExists]);
      });
    }
  },
  triggerFallbackStream(state) {
    state.triggerFallbackStream = true;
    Vue.nextTick(() => {
      state.triggerFallbackStream = false;
    })
  },
  // -- BROADCAST CODE ENDS
  setBulbIsPD(state) {
    state.bulbIsPD = true;
  },
  setSlider(state, sliderObject) {
    state.slider = sliderObject;
  },
  setVimeoEmbedPlayerCaptions(state, vimeoVideoCaptionInfo) {
    const { vimeoVideoIds: { sourceId, privateId }, tracks } = vimeoVideoCaptionInfo;
    state.bulb.bulbVideos.forEach( (bulbVideo) => {
      const stream = bulbVideo.bulbVideoStreams.find(
        (stream) => (
          stream.type === 'vimeo'
          && (
            stream.url.includes(sourceId)
            || stream.url.includes(privateId)
          )
        )
      );
      if (stream) Vue.set(bulbVideo, 'bulbVideoCaptions', tracks);
    });
  },
  setInvokeVimeoFallbackCaptionLogic(state, value) {
    state.invokeVimeoFallbackCaptionLogic = value;
  },
  setHideCaptionsEnableTranscript(state, value) {
    state.hideCaptionsEnableTranscript = value;
  },
  updatePpWrapper(state, ppWrapper) {
    state.ppWrapper = ppWrapper;
  },
  setThirdPartyCookiesEnabled(state, value) {
    state.thirdPartyCookiesEnabled = value;
  },
  setLti13Launch(state, value) {
    state.lti13Launch = Boolean(value);
  },
  setLMSIssuer(state, value) {
    state.lmsIssuer = value;
  },
}

const getters = {
  shouldUseYoutubeEducationPlayer: (state, getters) => {
    return (
      !!state.youtubePlayerConfiguration
      && !!getters.schoolId
      && !state.bulb.teachers[0]?.school?.permissionKeys?.includes('useOldYoutubePlayerApi')
    );
  },
  activeInteractionGroup: (state, getters, rootState, rootGetters) => _.filter(rootGetters['interactions/interactionStates'], {'inDisplayRange':true}),
  activePausingInteractions: (state, getters) => _.filter(getters.activeInteractionGroup, 'pause'),
  allowRewind: (state, getters, rootState, rootGetters) => {
    // allows rewind if user is teacher in instructor preview mode
    if ((rootGetters['player/user'].userType === 'teacher' && rootState.player.playbackModeType === 'instructor') || rootGetters['player/user'].isTeacherLmbAttempt) return true;
    return  _.reduce(rootGetters['interactions/activeInteractionGroup'], (allowRewind, i) => {
      return allowRewind && (i.interaction.rewind || i.interactionMeta.isInteractionAnswered);
    }, true);
  },
  branding: (state) =>  {
    if ( _.has(state,'bulb.teachers') && _.has(state.bulb.teachers[0],'school') && state.bulb.teachers[0].school ){
      return {
        activeColor: (() => {
          // use query param
          if (state.queryParams.get('activeColor')) return state.queryParams.get('activeColor');
          // else use school color or default blue
          return state.bulb.teachers[0].school.activeColor || '#2196F3' // use active color or default blue
        })(),
        baseColor: (() => {
          // use query param
          if (state.queryParams.get('baseColor')) return state.queryParams.get('baseColor');
          // use db baseColor
          if (state.bulb.teachers[0].school.baseColor) return state.bulb.teachers[0].school.baseColor
          // if no baseColor, use darkend primary color
          else if (state.bulb.teachers[0].school.activeColor) return Color(state.bulb.teachers[0].school.activeColor).darken(.4).hex()
          // else use default dark blue
          return '#1976D2';
        })(),
        inactiveColor: (() => {
          // use query param
          if (state.queryParams.get('inactiveColor')) return state.queryParams.get('inactiveColor');
          // else use school color or default to white
          return state.bulb.teachers[0].school.inactiveColor || '#FFF'
        })(),
        logo: (() => {
          // use query param
          if (state.queryParams.get('brandLogo')) return state.queryParams.get('brandLogo')
          // else use school default
          return state.bulb.teachers[0].school.logo || null
        })(),
      }
    }
    return {
      activeColor: '#2196F3',
      baseColor:'#1976D2',
      inactiveColor:'#FFF',
    }
  },
  broadcastTeacher: (state, getters) => (state.isBroadcast && (getters.user && getters.user.userType === 'teacher')) || false,
  broadcastStudent: (state, getters) => (state.isBroadcast && (getters.user && getters.user.userType === 'student')) || false,
  bulb: state => state.bulb,
  bulbAttempt: state => state.bulbAttempt,
  bulbCopyName: state => state.bulbCopyName,
  bulbFinished: (state, getters, rootState, rootGetters) => {
    // if we're in the last 200ms (all Qs should appear ~250ms before end) and all required questions are answered
    return !rootGetters['interactions/hasRequiredInteractions'] && (getters.displayTime > (getters.displayDuration - .2));
  },
  bulbInitialized: (state) => {
    if (_.has(state,'bulb.bulbVideos') && state.bulb.bulbVideos.length > 0) {
      let initialized = true;
      state.bulb.bulbVideos.forEach((bulbVideo, i) => {
        if (!(bulbVideo.deviceInitialized && bulbVideo.videoInitialized)) initialized = false;
      })
      return initialized;
    }
    return false;
  },
  phpApiPrefix: (state) => state.phpApiPrefix,
  bulbVideos: (state) => state.bulb.bulbVideos,
  captionReset: (state) => state.captionReset,
  closeBulbInfo: state => state.closeBulbInfo,
  copyingBulb: state => state.copyingBulb,
  currentSegmentSeek: state => state.currentSegmentSeek,
  displayTimeStart: state => state.displayTimeStart,
  groupFuzz: state => state.groupFuzz,
  isLmb: state => state.bulb.lmbId > 1,
  interactionAttempts: state => state.bulbAttempt.interactionAttempts,
  interactionRequest: state => state.interactionRequest,
  desiredState: state => state.desiredState,
  displayTime: state => state.displayTime,
  displayDuration: state => {
    let duration = 0
    if (_.has(state, 'bulb.bulbVideos')) {
      state.bulb.bulbVideos.forEach((v, i) => {
        duration += v.displayDuration
      });
    }
    return duration;
  },
  duration: (state, getters,) => state.formatedDuration(getters.displayDuration),
  /*
		For schools below (Upper Canada - 1300 & TechConnect) we hide the Player mimic to expose the raw YouTube controls to trigger YouTube views.
		This only affects the first YouTube video in a bulb.
		Due to accessibilty - for all bulbs that don't have exposeYouTubeControls we hide the player-container so it is out of view/tab
		order and not visible until the play button is clicked.
	*/
  exposeYouTubeControls: (state) => {
		if (
			[1300, 2088].includes(_.get(state.bulb, 'teachers[0].school.id'))
			&& state.bulb.bulbVideos[0].bulbVideoStreams[0].type === 'youtube'
			&& !state.youTubePlayClicked
			) {
				return true;
			}
		return false;
	},
  fullScreenIcon: (state) => {
    return !state.isFullScreen ? 'fullscreen' : 'fullscreen_exit';
  },
  hidePlayControlsForVimeo: (state) => {
    return state.isVimeoIframe && !state.vimeoInitialized;
  },
  hidePlayControlsForPanopto: (state) => {
    return state.isPanoptoEmbeddedIframe && !state.panoptoInitialized;
  },
  hidePlayerControlsOnMobileIOSForPanopto: (state) => {
    return state.panoptoInitializing;
  },
  triggerFallbackStream: (state) => state.triggerFallbackStream,
  hasRubric: (state, getters, rootState, rootGetters) => {
    return rootGetters['interactions/rubricInteractions'].length > 0;
  },
  initializingBulb: state => state.initializingBulb,
  isBarbri: (state, getters) => {
    return [883, 1470, 2233, 2234, 2235, 2611].includes(getters.schoolId);
  },
  isDebugFriendlyBulbInBarbriApp: (state, getters) => {
    return (
      getters.isBarbri
      && getters.isWebview
      && [
        1254653,
        1254661,
        868150,
        868149,
        1223960,
        1128213,
      ].includes(state.bulb.id)
    );
  },
  isStrayer: (state, getters) => {
    return [906, 1179, 1965, 1966, 1967, 2392, 2754].includes(getters.schoolId);
  },
  isBroadcast: state => state.isBroadcast,
  isBroadcastTeacher: state => state.isBroadcastTeacher,
  isBroadcastStudent: state => state.isBroadcastStudent,
  isListcode: state => state.isListcode,
  isLmb: state => state.bulb.lmbId > 1,
  isPeerReview: state => _.has(state.bulb, 'config.lmb.peer_review') ? state.bulb.config.lmb.peer_review : false,
  isPlaylist: state => state.isPlaylist,
  hasPlaylistScoreThreshold: state => state.hasPlaylistScoreThreshold,
  hasNewInteractionDisplayAccess: state => {
    return (
      (
        _.get(state.bulb, 'config.bulbPlayback.hasNewInteractionDisplayAccess', false)
        || _.get(state, 'bulb.teachers[0].school.config.permissions', []).includes('hasNewInteractionDisplayAccess')
        || state.hasNewInteractionDisplayAccess
      )
      /*
      * liveSessions have not been set up to work with the newInteractionDisplay changes - Due to being in a Barbri blackout period we are disabling this for liveSession
      * at this time.  Adding a call to setInteractionStates into the liveSession flow *should* be all that is needed to correct this, but figuring out when/where will be tricky
      */
      && !state.isLiveSession
    )
  },
  hasPlayerKeyboardShortcutsFeature: state => {
    return _.get(state, 'bulb.masterTeacher.school.permissionKeys', []).includes('hasPlayerKeyboardShortcuts');
  },
  hasVimeoReorderStreamsFeature: (state) => {
    return (
      _.get(state, 'bulb.masterTeacher.school.config.permissions', []).includes('hasVimeoReorderStreams')
      || _.get(state, 'bulb.config.hasVimeoReorderStreams', false)
    );
  },
  hasInteractionSubmitContinuePlaybackFeature: (state) => {
    return _.get(state, 'bulb.masterTeacher.school.permissionKeys', []).includes('hasInteractionSubmitContinuePlayback');
  },
  hasPlayerVhsLogging: (state) => {
    return (
      _.get(state, 'bulb.masterTeacher.school.permissionKeys', []).includes('hasVhsLoggingAccess')
      || _.get(state, 'bulb.config.hasVhsLoggingEnabled', false)
    );
  },
  hasPlayerFadeInTransitionFeature: (state) => {
    return (
      _.get(state, 'bulb.masterTeacher.school.permissionKeys', []).includes('hasPlayerFadeInTransition')
      || _.get(state, 'bulb.config.hasPlayerFadeInTransition', false)
    );
  },
  hasPlayerContinuePlaybackOnWindowUnloadFeature: (state) => {
    return (
      _.get(state, 'bulb.masterTeacher.school.permissionKeys', []).includes('hasPlayerContinuePlaybackOnWindowUnloadFeature')
      || _.get(state, 'bulb.config.hasPlayerContinuePlaybackOnWindowUnloadFeature', false)
    );
  },
  hasFreeResponseEdit: (state) => {
    return (
      _.get(state, 'bulb.masterTeacher.school.permissionKeys', []).includes('hasFreeResponseEdit')
      || _.get(state, 'bulb.config.hasFreeResponseEdit', false)
    );
  },
  isWebview: (state, getters) => {
    const userAgent = state.userAgent.ua.toLowerCase();
    const safari = /safari/.test(userAgent);
    const chrome = /crios/.test(userAgent);
    if (getters.mobileIOS) {
        if (safari || chrome) {
            // browser
            return false;
        } else if (!safari) {
            // webview
            return true;
        };
    } else if (state.userAgent.os.name === 'Android') {
      return /(Version\/\d+.*\/\d+.0.0.0 Mobile|; ?wv)/i.test(userAgent);
    }
    return false;
  },
  hasRubric: state => _.has(state.bulb, 'config.lmb.pr_rubric') ? state.bulb.config.lmb.pr_rubric : false,
  lmsLaunch: state => state.lmsLaunch,
  lmbTeacherAttempt: (state, getters) => _.has(getters.user, 'lmbTeacherAttempt') ? state.user.lmbTeacherAttempt : false,
  lookaround: state => state.lookaround,
  ltiExporting: state => state.ltiExporting,
  ltiExportFailed: state => state.ltiExportFailed,
  manualPause: state => state.manualPause,
  manualPlay: state => state.manualPlay,
  maxTime: state => state.maxTime,
  minSidebarPercent: state => state.minSidebarPercent,
  minSidebarPx: state => state.minSidebarPx,
  mute: state => _.has(state, 'bulb.config.mute') ? state.bulb.config.mute : false,
  playerApiPrefix: state => state.playerApiPrefix,
  playerState: state => state.playerState,
  requiredMaxTime: (state, getters, rootState, rootGetters) => {
    const requiredIncomplete = _.filter(rootGetters['interactions/interactionStates'], (is => {
      if (is.interaction.config.template_key === 'rubric') return false;
      return (
        is.interaction.isRequired
        && (
          !is.interactionMeta.isInteractionAnswered
          || state.isLiveSession
        )
      );
    }));
    if (requiredIncomplete.length) {
      return _.min(_.flatMap(requiredIncomplete, x => parseFloat(x.interaction.displayOutTime)))
    } else {
      return getters.displayDuration;
    }
  },
  previousSessionTime: state => state.previousSessionTime,
  queryParams: state => state.queryParams,
  runtime: state => state.formatedDuration(state.displayTime),
  reversedRuntime: (state, getters) => state.formatedDuration((getters.displayDuration - state.displayTime)),
  schoolId: state => {
    if (_.has(state.bulb, 'teachers')) {
      return _.has(state.bulb.teachers[0], 'school.id') ? state.bulb.teachers[0].school.id : null;
    }
    return false;
  },
  screenWidth: state => state.dimensions.width,
  screenHeight: state => state.dimensions.height,
  screenRatio: (state, getters) => getters.screenWidth / getters.screenHeight,
  scrubbing: state => state.scrubbing,
  sessionStartTime: state => state.sessionStartTime,
  settingsMenu: state => state.settingsMenu,
  showCopyBulbModal: state => state.showCopyBulbModal,
  showInteractionsTab: state => state.showInteractionsTab,
  sidebarDragging: state => state.sidebarDragging,
  sidebarTab: state => state.sidebarTab,
  sidebarTransitioned: state => state.sidebarTransitioned,
  sidebarWidth: state => state.sidebarWidth,
  sidebarOpen: (state, getters) => {
    if (getters.sidebarStyle === 'portrait') return true;
    return state.sidebarOpen;
  },
  sidebarStyle: (state, getters) => {
    // determines sidebar style that triggers profile, landscape, or desktop player mode
    if ([
      'portrait',
      'landscape',
      'desktop',
    ].includes(state.lockedSidebarStyle)) return state.lockedSidebarStyle;
		let style = 'desktop';
		if (getters.mobile) {
			if (getters.screenWidth < 700) {
				style = 'portrait';
      }
      if (getters.screenWidth - getters.screenHeight > 1 && getters.screenWidth > 700 ) {
        style = 'desktop';
      } else if (getters.screenWidth - getters.screenHeight > 1 && getters.screenWidth < 700) {
        style = 'landscape';
      } else {
        style = 'portrait';
      }
		} else {
			if (getters.screenWidth <= 425 && getters.screenRatio < .7) {
				style = 'portrait';
			}
			else if (getters.screenWidth < 700 && state.queryParams.get('playlist') !== 'true') {
				style = 'landscape';
			}
			else {
				style = 'desktop';
			}
		}
		return style;
	},
  sidezoneOpen: (state, getters) => {
    if (getters.sidebarStyle === 'portrait') return true;
    return state.sidezoneOpen;
  },
  slideInteraction: (state) => state.slideInteraction,
  smallScreen: (state) => state.smallScreen,
  snackbar:(state) => state.snackbar,
  tokenRefresh: state => state.tokenRefresh,
  ltiSynced:(state) => state.ltiSynced,
  speed: state => _.has(state, 'bulb.config.speed') ? state.bulb.config.speed : 1,
  volume: state => _.has(state, 'bulb.config.volume') ? state.bulb.config.volume : 0,
  user: (state, getters) => {
    const u =  state.user;
    u.isLti = (
      (
        !!_.get(state, 'bulbAttempt.resourceLinkId') // resourceLink exits and not launched from playlist
        && !getters.isPlaylist
      ) || _.get(state, 'bulbAttempt.isLti', null) // instructor launch will check if section is LTI and attach to bulbAttempt - specfically for broadcast
    );
    if (
      u.userType === 'student'
      && u.isLti
    ) {
      const resourceLinkInfo = state.bulbAttempt.resourceLinkId.split(/_(.+)/);
      u.consumerKey      = resourceLinkInfo[0] || null;
      u.resourceLinkId   = resourceLinkInfo[1] || null;
      u.gradePassbackUrl = (
        u.isLti
        && (!getters.isPlaylist) ? state.user.gradePassbackUrl : null
      );
      // Due to how we are storing that field on the LTI 1.3 table:
      if (Array.isArray(u.enableGrading?.data)) u.enableGrading = u.enableGrading?.data?.[0];
    }
    return u;
  },
  userAgent: (state) => state.userAgent,
  youtubeActiveStream: (state) => state.youtubeActiveStream,
  ytInitializing: state => state.ytInitializing,
  ytInitialized: state => state.ytInitialized,
  vimeoInitializing: state => state.vimeoInitializing,
  vimeoInitialized: state => state.vimeoInitialized,
  panoptoInitializing: state => state.panoptoInitializing,
  panoptoInitialized: state => state.panoptoInitialized,
  ytVr: state => state.ytVr, // boolean to disable overlay-container for youtube vr, temp until we get videojs-vr going
  enableYoutubeFriendlyUi: (state, getters) => {
    return (
      getters.ytVr
      && state.bulb?.teachers?.[0]?.school?.permissionKeys?.includes('enableYoutubeFriendlyUi')
    );
  },
  mobile: state => {
    let isIOS = ( /iPad|iPhone|iPod/.test(window.navigator.platform) ||
                  (window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1) // duct tape to detect ipads on iOS 13+
                ) &&
                !window.MSStream;
    if (isIOS) return true;
    if (state.userAgent) {
      return ['mobile', 'tablet'].includes(state.userAgent.device.type) ;
    }
    return false;
  },
  mobileIOS: state => {
    const userAgent = state.userAgent.ua.toLowerCase();
    const ios = /iphone|ipod|ipad/.test(userAgent);
    // Testing for the platform type and maxTouchPoints is duct tape to detect ipads on iOS 13+) 
    if (ios || (window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1)) return true;
    return false;
  },
  isProquestBulb: (state) => {
    return !!_(state.bulb?.bulbVideos)
      .map('video')
      .flattenDeep()
      .map('videoStreams')
      .flattenDeep()
      .value()
      .find(({ type } = {}) => type === 'proquest');
  },
  isVimeoBulb: (state) => {
    return !!_(state.bulb.bulbVideos)
      .map('video')
      .flattenDeep()
      .map('videoStreams')
      .flattenDeep()
      .value()
      .find(({ type } = {}) => type === 'vimeo');
  },
  termForBulb: (state, getters) => {
    return getters.isProquestBulb ? 'interaction' : 'bulb';
  },
  termForBulbArticle: (state, getters) => {
    return getters.isProquestBulb ? 'an' : 'a';
  },
  // -- BROADCAST CODE STARTS
  broadcastId: state => state.broadcastId,
  broadcastActiveInteractionId: state => state.broadcastActiveInteractionId,
  broadcastDisplayTime: state => state.broadcastDisplayTime,
  broadcastTeacherStatus: state => state.broadcastTeacherStatus,
  broadcastLearners: state => state.broadcastLearners,
  showBroadcastStartBtn: state => state.showBroadcastStartBtn,
  // -- BROADCAST CODE ENDS
}
const actions = {
  async copyBulb({
    getters,
    state,
    commit,
  }, {
    bulb_id: bulbId,
    name,
    edit,
  } = {}) {
    try {
      commit('setShowCopyBulbModal', false);
      if (_.get(getters, 'user.userType') !== 'teacher') {
        window.location = `https://www.playposit.com/copyBulbLogin/${bulbId}?name=${encodeURI(name)}${edit ? '&edit=true' : ''}`;
        return;
      }
      state.copyingBulb = true;
      commit('setSnackbar', {
        text: `Copying ${getters.termForBulb.capitalize()}`,
        spinner: true,
        timeout: 0,
      });
      const { data: copiedBulb } = await PlayerService.copyBulb({
        id: bulbId,
        name,
        newDb: true,
        fullCopy: true, // will need to update copy modal to toggle this value
      });
      if (!copiedBulb.id) return alert(`Sorry! There was an error coping the ${getters.termForBulb}.`);
      commit('setSnackbar', {
        color: 'success',
        text: `${getters.termForBulb.capitalize()} Copied`,
        timeout: 5000,
      });
      if (edit) {
        window.location.href = `/designer/?bulb_id=${copiedBulb.id}&token=${getters.user.token}`;
      } else {
        window.location.href = `/dash/?token=${getters.user.token}`;
      }
      return copiedBulb;
    } catch(e) {
      commit('setSnackbar', {
        color: 'error',
        text: _.get(e, 'msg', `Unable to copy ${getters.termForBulb}`),
      });
      throw e;
    } finally {
      state.copyingBulb = false;
    }
  },
  checkYoutubeBlocked: (context) => {
    return new Promise((resolve, reject) => {
      const youtubeScriptSrc = context.getters.shouldUseYoutubeEducationPlayer
      ? `https://www.youtubeeducation.com/iframe_api`
      : 'https://www.youtube.com/iframe_api';
      const schoolId = _.has(context.getters.bulb.teachers[0], 'school.id') ? context.getters.bulb.teachers[0].school.id  : 'none';
      const hasProxy = _.has(context.getters.bulb.teachers[0], 'school.proxy') && context.getters.bulb.teachers[0].school.proxy;
      const streams = _.map(context.getters.bulb.bulbVideos, bv => { return {bv: bv.id, len: bv.bulbVideoStreams.length}})

      const checkLoaded = () => {
        // wait 5 seconds then check to see if yt object has been loaded
        setTimeout(() => {
          if (!window['YT'] || !window['YT'].loaded) {
            PlayerService.apiLogger(`youtube window YT not loaded within 200ms for bulb ${context.getters.bulb.id} section ${context.getters.bulbAttempt.sectionId} student ${context.getters.bulbAttempt.studentId} school ${schoolId} window yt ${JSON.stringify(window['YT'])} has proxy ${hasProxy} stream ${JSON.stringify(streams)} ` )
            return resolve(true);
          } else {
            return resolve(false);
          }
        }, 5000);
      }

      const checkWidget = () => {
        // check if secondary youtube script tag has been added
        if (document.getElementById('www-widgetapi-script')) {
          // s.ytimg script tag has been added, wait for it to load
          checkLoaded();
        } else if ( document.querySelector(`script[src="${youtubeScriptSrc}"]`) )  {
          // s.ytimg script tag has not been loaded
          checkLoaded();
        } else {
          // youtube is blocked
          PlayerService.apiLogger(`youtube widgetapi-script unable to load for bulb ${context.getters.bulb.id} section ${context.getters.bulbAttempt.sectionId} student ${context.getters.bulbAttempt.studentId} school ${schoolId} has proxy ${hasProxy} stream ${JSON.stringify(streams)}` )
          return resolve(true);
        }
      }

      if (window['YT'] ) {
        // youtube object exists on the page, check if secondary script has been added
        checkWidget();
      } else {
        // youtube is not on the page, load iframe_api script tag to check blocking (stolen from videojs-youtube)
        let loaded = false;
        const tag = document.createElement('script');
        const firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        tag.onload = (e) =>  {
          if (!loaded) {
            loaded = true;
            checkWidget();
          }
        };
        tag.onreadystatechange = (e) =>  {
          if (!loaded && (this.readyState === 'complete' || this.readyState === 'loaded')) {
            loaded = true;
            checkWidget()
          }
        };
        tag.onerror = () => {
          // PlayerService.apiLogger(`youtube iframe_api unable to load for bulb ${context.getters.bulb.id} section ${context.getters.bulbAttempt.sectionId} student ${context.getters.bulbAttempt.studentId} school ${schoolId} has proxy ${hasProxy} stream ${JSON.stringify(streams)}` )
          return resolve(true);
        }
        tag.src = youtubeScriptSrc;
      }
    })
  },
  sessionTime(context) {
		return moment.duration(moment().diff(context.getters.sessionStartTime)).asSeconds() + context.getters.previousSessionTime;
	},
	sessionToDisplayTime(context) {
	  /*
	    If the liveSessionUnixTime is in the range of an interaction sets
	    the activeInteraction to that actualInteraction to set is as the active player interaction
	    we also keep track of the jumpDisplayTime in case the playerTime and the liveSessionUnixTime
	    get out of sync - so we can jump to the correct playerTime.
	  */
	  let jumpDisplayTime = context.state.liveSessionUnixTime;
	  // Loop through interactions to see if they need to be displayed.
	  for (const interaction of context.state.liveSessionTimeArray) {
	    const actualInteraction = context.rootGetters['interactions/interaction'](interaction.interactionId);
	    const actualInteractionMeta = context.rootGetters['interactions/interactionMeta'](interaction.interactionId);
	    // liveSessionUnixTime is past interaction
	    if (context.state.liveSessionUnixTime >= interaction.unixDisplayOutTime) {
	      jumpDisplayTime = interaction.playerDisplayOutTime + (context.state.liveSessionUnixTime - interaction.unixDisplayOutTime);
	      // We are past the interaction. - Set it to no longer be required.
	      if (actualInteraction.isRequired) actualInteraction.isRequired = false;
	    }
	    // An interaction time is in the range of liveSessionUnixTime
	    else if (context.state.liveSessionUnixTime >= interaction.unixDisplayInTime && context.state.liveSessionUnixTime < interaction.unixDisplayOutTime) {
	      jumpDisplayTime = _.min([interaction.playerDisplayInTime + (context.state.liveSessionUnixTime - interaction.unixDisplayInTime), interaction.playerDisplayOutTime]);
	      if (!actualInteractionMeta.viewed || (actualInteractionMeta.viewed && Math.abs(actualInteraction.displayOutTime - context.state.displayTime) < 1) && !actualInteractionMeta.pastInteractionOffset) {
	        context.dispatch('interactions/requestSetActiveInteraction', actualInteraction, { root: true });
	      }
	      break;
	    }
	    // liveSessionUnixTime is before interaction
	    else if (context.state.liveSessionUnixTime < interaction.unixDisplayInTime) {
	      break;
	    }
	  }
	  const outOfSyncTime = context.getters.mobile ? 10 : 5;
	  if (Math.abs(jumpDisplayTime - context.state.displayTime) > outOfSyncTime) {
	    if (!context.state.shownOutOfSyncToast) {
	      context.state.shownOutOfSyncToast = true;
	      context.commit('setSnackbar', {
          color: 'warning',
          text: 'Out of sync.  Syncing...',
          timeout: 5000,
        });
	    }
	    EventBus.$emit('requestAction', {
        key: 'seek', seekTime: jumpDisplayTime, preventSyncState: true
      });
      EventBus.$emit('requestAction', { key: 'play', setDesiredState: true });
	  }
    // These are left on purpose for future debugging needs
    // console.log('jumpDisplayTime: ', jumpDisplayTime);
    // console.log('liveUnixTime: ', context.state.liveSessionUnixTime);
	},
	setupLiveSessionData: (context) => {
	  // Set the bulb to allow fastForward
	  context.state.bulb.config.fast_yes = true;
	  context.state.bulb.config.retry_yes = false;
	  let interactionUnixOffset = 0;
    let interactionUnixPlaceholder;
      _.orderBy(context.rootState.interactions.interactions, 'displayOutTime').forEach((i, index) => {
        const offset = ['multiple_choice', 'check_all_apply', 'poll_q'].includes(i.interactionType) ? _.get(i, 'config.interaction_offset', 12) : 0;
        interactionUnixPlaceholder = ( // This only tracks time spent on interactions 
          interactionUnixOffset
          + _.get(i, 'config.session_duration', 20)
          + offset
        );
        Vue.set(state.liveSessionTimeArray, state.liveSessionTimeArray.length, {
          interactionId: i.id,
          interactionDuration: _.get(i, 'config.session_duration', 20),
          unixDisplayInTime: i.displayInTime + interactionUnixOffset,
          playerDisplayInTime: i.displayInTime,
          unixDisplayOutTime: interactionUnixPlaceholder + i.displayOutTime,
          playerDisplayOutTime: i.displayOutTime,
          interactionOffset: offset,
          interactionUnixOffset,
        });
        // Set pause and required to false
        i.pause = false;
        i.isRequired = true;
        interactionUnixOffset = interactionUnixPlaceholder;
        // On the last loop set the unixBulbEndTime
        if (index === context.rootState.interactions.interactions.length - 1) {
          context.commit('setUnixBulbEndTime', context.state.liveSessionStartTime + interactionUnixPlaceholder + context.getters.displayDuration);
          // This console.log is intentional to allow for testing
          console.log('sessionDuration: ' + (context.getters.displayDuration + interactionUnixPlaceholder));
        }
    });
    // if there aren't any interactions - set the unixBulbEndTime to the startTime + displayDuration
    if (!context.state.unixBulbEndTime) context.commit('setUnixBulbEndTime', context.state.liveSessionStartTime + context.getters.displayDuration);
	},
	async syncLocalUnixTime(context) {
	  /*
	    Every machine has a slightly different local time - he make a call to get the server time and use that
	    as the source of truth.  We then adjust the start time to the difference between the local unix timestamp
	    and the unix timestamp returned by the server.  This syncs each machine to within a second.
	  */
	  try {
	    // get unix timestamp from server
	    const actualUnixTime = await axios.get('https://unix.playpos.it/', {
	      transformRequest: (data, headers) => {
          delete headers.common['Authorization'];
        },
        timeout: 1500,
      });
	    if (actualUnixTime.status === 200) {
	      // calculate the offset fromt he server timestamp
	      context.state.localUnixTimeOffset = parseInt((new Date().getTime() / 100).toFixed(0), 10) / 10 - actualUnixTime.data;
	      // set the adjusted sessionStartTime
        context.commit('setLiveSessionStartTime',
          parseInt((new Date(_.get(state.bulb, 'sections[0].bulbSection.sessionStartTime')).getTime() / 1000).toFixed(0), 10)
          + context.state.localUnixTimeOffset
        );
        // Update the endtime with the offset
        context.commit('setUnixBulbEndTime', context.state.unixBulbEndTime + context.state.liveSessionStartTime + context.state.localUnixTimeOffset);
	    }
	    // Check to see if the session has ended.
      if (parseInt((new Date().getTime() / 1000).toFixed(0), 10) > context.state.unixBulbEndTime) {
        this._vm.$enablePlaypositErrorScreen({
          vertical: true,
          active_color: context.getters.isBarbri ? '#235BA8' : this._vm.$vuetify.theme.primary,
          base_color: this._vm.$vuetify.theme.secondary,
          inactive_color: this._vm.$vuetify.theme.tertiary,
          title: context.getters.isBarbri ? '' : 'Session Complete',
          subtitle: context.getters.isBarbri ? 'Today\'s virtual class session is complete' : `The ${context.getters.termForBulb} session has ended.`,
          code: context.getters.isBarbri ? '' : _.get(context, 'state.sessionId', 101),
          text: context.getters.isBarbri ? '' : `Please launch the asynchronous ${context.getters.termForBulb} from your PSP dashboard.`,
          icon: context.getters.isBarbri ? '' : 'hourglass_disabled',
          logoURL: context.getters.isBarbri ? 'https://cdn.playposit.com/image-uploads/image-05-03-2020-02-42-10--barbri3.png' : '',
          buttons: [],
        });
      }
	  } catch(e) {
	    console.error('Error syncing local unix time.', e);
	  }
	},
  syncLtiGrade: (context, notify = true) => {
    if (!context.getters.user.isLti) return 'not an LTI user';
    if (context.getters.isPlaylist) return `cannot export ${context.getters.termForBulb} launched from playlist`;
    if (context.getters.user.readOnly) notify = false;
    context.state.ltiExporting = true;
    let syncObj = {
      bulb_id: context.getters.bulbAttempt.bulbId,
      section_id: context.getters.bulbAttempt.sectionId,
      student_id: context.getters.bulbAttempt.studentId,
      resource_link_id: context.getters.bulbAttempt.resourceLinkId.split(/_(.+)/)[1],
      consumer_key: context.getters.bulbAttempt.resourceLinkId.split(/_(.+)/)[0],
      start_time: moment().format('MM-DD-YYYY:HH:MM:SS'),
      lti13Launch: !!context.state.lti13Launch,
      issuer: context.state.lmsIssuer,
    };
    PlayerService.syncLTIGrade(syncObj)
    .then((res) => {
      context.state.ltiExporting = false;
      if (notify) {
        context.dispatch('ltiStatusToast', res.data.syncStatus.msg);
      }
    }).catch((err) => {
      context.state.ltiExporting = false;
      context.state.ltiExportFailed = true;
      if (notify) {
        context.commit('setSnackbar',
        {
          color: 'red',
          text: 'Grade sync failed. Try again later.',
        }
        );
      }
    });
  },
  syncLtiGradeStatus: async (context) => {
    try {
      const syncObj = {
        bulb_id:    context.getters.bulbAttempt.bulbId,
        section_id: context.getters.bulbAttempt.sectionId,
        student_id: context.getters.bulbAttempt.studentId,
      };
      const res = await PlayerService.syncLTIGradeStatus(syncObj)
      context.dispatch('ltiStatusToast', res.data.syncStatus.msg);
    } catch (error) {
      dataLayer.errorLog(
        error, {
          sessionId: state.sessionId,
      });
    }
  },
  ltiStatusToast: (context, msg) => {
		if (
      [
        LTI_GRADE_SYNC_STATUS_MESSAGE.LTI_11.Success,
        LTI_GRADE_SYNC_STATUS_MESSAGE.LTI_13.Success
      ].includes(msg)
    ) {
			context.commit('setLtiSynced', true);
			context.commit('setSnackbar',{ color: 'success', text: msg });
		} else if (msg === 'Export Not Started') {
			context.commit('setLtiSynced', false);
			context.commit('setSnackbar',{ color: 'warning', text: msg });
		} else {
			// all other situations
			context.commit('setLtiSynced', 'pending');
			context.commit('setSnackbar',{ color: 'info', text: msg });
		}
  },
  replayVideo: ({commit}) => {
    commit('setDesiredState', 'play');
    EventBus.$emit('replayVideo');
  },
  togglePlay: context => {
    if(!context.getters.isBroadcast || (context.getters.isBroadcast && (context.getters.user && context.getters.user.userType === 'teacher'))) {
      if (context.getters.playerState === 'paused') {
        context.commit('setManualPlay', true);
        context.commit('setDesiredState', 'play');
        EventBus.$emit('requestPlay');
      } else {
        context.commit('setManualPause', true);
        EventBus.$emit('requestAction', { key: 'pause', setDesiredState: true });
      }
    }
  },
  togglePlaybackMode: (context, data) => {
    // Original values is an object of interactions from initial API call plus the original bulb fast_yes setting
    if (data.playbackModeType === 'learner') {
      context.commit('updateFastYes', data.originalValues.bulb.fast_yes);
      for(const interactionId of data.originalValues.requiredInteractions) {
        context.commit('interactions/updateInteractionRequired', {
          interactionId,
          isRequired: true
        }, {root: true});
      }
    } else {
	    context.commit('updateFastYes', true);
	    for (const interactionId of data.originalValues.requiredInteractions) {
        context.commit('interactions/updateInteractionRequired', {
          interactionId,
          isRequired: 0
        }, {root: true});
      }
	  }
	  // Sets the maxTime based on fast_yes setting
	  if (!context.state.bulb.config.fast_yes) context.commit('setMaxTime', Math.min(context.getters.requiredMaxTime, context.state.displayTime));
	  else (context.commit('setMaxTime', context.getters.requiredMaxTime));
  },
  updateBulbVideoDuration: (context, data) =>  {
    const newPlayerDuration = data.duration;
    const bulbVideoId = data.bulbVideoId
    let dur = 0;
    context.rootState.player.bulb.bulbVideos.forEach((bulbVideo) => {
      if (bulbVideoId === bulbVideo.id) {
        bulbVideo.video.playerDuration = newPlayerDuration;
      	// only update bulbVideo that was adjusted
        bulbVideo.allCrops = [];
      	//update end crop
    		bulbVideo.playerEndTime = bulbVideo.playerEndTime > 0 ? Math.min(newPlayerDuration, bulbVideo.playerEndTime) : newPlayerDuration;
      	// add start crop
      	if (bulbVideo.playerStartTime > 0) bulbVideo.allCrops.push({start: 0, end: bulbVideo.playerStartTime})
      	// add end crop
      	if (bulbVideo.playerEndTime < newPlayerDuration) bulbVideo.allCrops.push({start: bulbVideo.playerEndTime, end: newPlayerDuration});
      	// limit crops to 0 < crop < newPlayerDuration and add to array
      	bulbVideo.skip.forEach(skip => {
      	  // defaults crops that are missing start
      	  if (_.isNil(skip.start)) skip.start = 0;
      	  // defaults crops that are missing end
      	  if (_.isNil(skip.end)) skip.end = 0;
      	  if (skip.start && skip.start < 0) skip.start = 0;
      	  if (skip.end && !_.isNil(bulbVideo.video.playerDuration) && skip.end > bulbVideo.video.playerDuration) skip.end = bulbVideo.video.playerDuration;
      	  if (skip.end - skip.start > 0) {
      	  //add skip segments to all crop array
      	  	bulbVideo.allCrops.push(skip)
      	  }
      	});
      	// remove duplicate skip segments
      	bulbVideo.allCrops = _.uniqWith(bulbVideo.allCrops, _.isEqual);
      	//calculate bulbVideo displayDuration
        bulbVideo.displayDuration = _.reduce(bulbVideo.allCrops, (duration, skip) => duration - (skip.end - skip.start), newPlayerDuration);
      }
      //set bulbVideo displayStart
      bulbVideo.displayStart = dur
      // set bulbVideo displayEnd
      bulbVideo.displayEnd = bulbVideo.displayStart + bulbVideo.displayDuration
      // increase accumulator for next bulbVideo's start time
      dur += bulbVideo.displayDuration;
    });

    let overflowIndex = 0;
    _.orderBy(context.rootState.interactions.interactions, 'displayInTime').forEach((i) => {
      // add defaults for questions here
      if (!i.displayOutTime || i.displayOutTime < i.displayInTime) i.displayOutTime = i.displayInTime;
      if (i.displayInTime >= dur - .1) {
        // offset displayInTime before duration but maintaining order of displayTime
        overflowIndex += 1;
        i.displayInTime = dur - (1 / overflowIndex / 100);
        i.displayOutTime = dur;
      }
      if (i.displayOutTime > dur) i.displayOutTime = dur;
    });
  },
  lockSidebarStyle({
    state,
    getters,
  }, lockedSidebarStyle) {
    if (lockedSidebarStyle === false) {
      state.lockedSidebarStyle = false;
    } else {
      state.lockedSidebarStyle = getters.sidebarStyle;
    }
  },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
